import UploadNewsForm from "../../UploadNewsForm";
import { createHistory } from "../../../api";
import { Container } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function CreateNewHistory() {
  const navigate = useNavigate();
  const customSubmitFunction = async (title, description, image) => {
    try {
      const result = await createHistory(title, description, image);
      if (result) {
        navigate("/history/all");
      }
    } catch (error) {}
  };
  return (
    <>
      <Container>
        <UploadNewsForm
          customsubmit={customSubmitFunction}
          breadCrumbLink={"History"}
          breadCrumbText={"Create New"}
          goBackLink={"/history/all"}
        />
      </Container>
    </>
  );
}
